<template>
  <div class="dashboard-view">
    <div class="page-wrapper">
      <!-- Apps -->
      <div v-if="appsSuite.length > 0" class="apps-wrapper">
        <!-- Info -->
        <div class="info-wrapper">
          <h3 class="section-title">Macha AI Apps</h3>
          <p>Manage Macha's apps to unlock AI for your workflows and agents</p>
        </div>

        <div class="apps-list">
          <!-- App -->
          <div
            v-for="app in appsSuite"
            :key="app.key"
            class="app"
            @click="gotoApp(app)"
          >
            <img :src="getAppIcon(app.appIcon)" :alt="app.title" />
            <span class="title">{{ app.title }}</span>

            <!-- Download status -->
            <div v-if="app.hasDownloaded" class="downloaded table-tag green">
              <unicon name="check"></unicon>
              <span>Downloaded</span>
            </div>
            <div v-else class="downloaded table-tag">
              <unicon name="check"></unicon>
              <span>Not Downloaded</span>
            </div>

            <!-- Button -->
            <button
              v-if="app.hasDownloaded"
              class="btn btn-small btn-icon btn-grey"
            >
              <unicon name="setting"></unicon>
              <span>Goto Settings</span>
            </button>

            <button
              v-else
              target="_blank"
              class="btn btn-small btn-icon btn-grey"
            >
              <unicon name="external-link-alt"></unicon>
              <span>View on Zendesk</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Pre Loader -->
      <PreLoader v-else :show="true" class="pre-loader"></PreLoader>
    </div>
  </div>
</template>

<script>
// Libraries
import _ from "lodash";

// Components
import PreLoader from "@/components/loaders/PreLoader";

export default {
  name: "AppsMain",
  data() {
    return {
      lodash: _,
      apps: [
        {
          key: "ticketTranslations",
          title: "Ticket Translations AI",
          route: "translations",
          zendeskAppId: "1166071",
          appIcon: "ticket-translations.png",
          hasDownloaded: false,
          app: {},
        },
      ],
      meta: {
        title: "Macha AI Apps",
        description: "",
      },
    };
  },

  components: {
    PreLoader,
  },

  computed: {
    user() {
      return this.$store.getters.user.user;
    },
    company() {
      return this.$store.getters.company;
    },
    appsSuite() {
      return this.$store.getters.appsSuite;
    },
  },

  async created() {
    this.$store.commit("updateSelectedApp", {});
  },
  methods: {
    // Get the Zendesk marketplace app link
    getZendeskMarketplaceLink(appId) {
      return `https://www.zendesk.com/in/marketplace/apps/support/${appId}`;
    },

    // Click action
    gotoApp(app) {
      if (app.hasDownloaded) {
        this.$router.push({ path: `/apps/${app.route}` });
      } else {
        window
          .open(this.getZendeskMarketplaceLink(app.zendeskAppId), "_blank")
          .focus();
      }
    },

    // Get app icon
    getAppIcon(icon) {
      let iconURL = `/assets/images/apps/${icon}`;
      return iconURL;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.pre-loader {
  flex: 1;
  margin: 3rem 15%;
  max-width: 60%;
}

.apps-wrapper {
  width: 100%;
  text-align: center;
  margin-top: 3rem;

  .info-wrapper {
    margin-bottom: 3rem;
  }
}

.apps-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  max-width: 60vw;
  margin: auto;
}

.app {
  text-align: center;
  cursor: pointer;
  flex: 1 1 9rem;
  max-width: 9rem;

  &:hover {
    img {
      transform: translateY(-0.3rem);
    }

    .btn {
      opacity: 1;
    }
  }

  img {
    display: block;
    width: 6rem;
    margin: 0 auto 1rem;
    border-radius: 0.85rem;
    border: 1px solid #ececec;
    transform: translateY(0);
    transition: all 0.3s;
  }

  .title {
    font-size: $smallFontSize;
    font-weight: $mediumFontWeight;
  }

  .btn {
    opacity: 0;
    margin: auto;
    padding: 5px;
    white-space: nowrap;
    margin-top: 2rem;
    justify-content: center;
    width: fit-content;
    padding-right: 0.75rem;
  }

  .downloaded {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    justify-content: center;
    border-radius: 0.5rem;
    margin: auto;
    padding: 0.15rem 0.5rem;
    gap: 0.15rem;

    margin-top: 0.25rem;

    .unicon ::v-deep svg {
      width: 1rem;
      height: auto;
      fill: lighten($greyColor, 15%);
      transform: translateY(1px);
    }

    span {
      font-size: $smallestFontSize;
      font-weight: $mediumFontWeight;
    }

    &.green {
      background-color: lighten($tagGreenBackgroundColor, 5%);

      .unicon ::v-deep svg {
        fill: darken($greenColor, 20%);
      }
    }
  }
}
</style>
